import { FormGroup } from 'reactstrap'
import { RadioButtonGroup } from 'common-components'

const PayerRelationSelection = ({ payerRelationOptions, payerRelation, selectPayerRelation }) => (
  <FormGroup id="payer-relation-selection" className="payer-selection">
    <RadioButtonGroup
      value={payerRelation}
      options={payerRelationOptions}
      onChange={selectPayerRelation}
      classNamePrefix="payer"
      autoClassName={true}
    />
  </FormGroup>
)

export default PayerRelationSelection
